import './toxilibs_base_url.js'
import eventBus from 'toxilibs/event_bus_queued.js'
import getUrlParams from 'toxilibs/url_params.js'
import $ from 'jquery'
import globals from './globals.js'
import initView from './view.js'
import enableOfflinePlay from './offline_play.js'

import './core/levels_navigator.js'
import './persistence/levels_storage.js'
import './remote_challenge.js'

import './modules/javascript.js'
import './modules/geometry.js'

//import './modules/math_formula.js'

import './modules/multiple_choices.js'
import './modules/icons.js'
import './modules/python.js'
import './modules/language_handler.js'

import './core/challenge_view.js'
import './stats.js'
import './user_progression.js'
import './user_history.js'


const urlParams = getUrlParams()


globals.ref     = urlParams.ref
globals.beneylu = urlParams.beneylu

initView()


eventBus.on('parkour synchronizer reset', function () {
    setTimeout(function () { //FIXME
        location.reload()
    }, 500)
})


$(function () {

    eventBus.emit('page loaded')

})


window.addEventListener('load', enableOfflinePlay) // after the page assets, not competing with them
